import { HealthTeam } from "@/@types/esus/HealthTeam";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { HomeVisit } from "@/@types/esus/HomeVisit";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";
import { IndicatorEsfStatusEnum } from "@/utils/enums/IndicatorEsfStatusEnum";

export type DetailedCitizensAcsVisitsIndicatorC4Params = Partial<PaginationFilter> & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	isEvaluated?: boolean;
	export?: boolean;
};

export class DetailedCitizenAcsVisitsIndicatorC4Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	healthUnitId: number = 0;
	healthTeamId: number = 0;
	healthUnit?: HealthUnit;
	healthTeam?: HealthTeam;
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	acsHomeVisits?: HomeVisit[];
	twoHomeVisitsStatus: IndicatorEsfStatusEnum = IndicatorEsfStatusEnum.Lost;
	firstAcsHomeVisit?: HomeVisit;
	firstAcsHomeVisitStatus: IndicatorEsfStatusEnum = IndicatorEsfStatusEnum.Lost;
	lastAcsHomeVisit?: HomeVisit;
}

export async function getDetailedCitizensAcsVisitsIndicatorC4({
	uf,
	ibgeCode,
	...params
}: DetailedCitizensAcsVisitsIndicatorC4Params) {
	const response = await esusApi.get<Paginated<DetailedCitizenAcsVisitsIndicatorC4Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c4/detailed-citizens-home-visits`,
		params
	);
	return response.data ?? new Paginated<DetailedCitizenAcsVisitsIndicatorC4Data>();
}
